module.exports = __webpack_public_path__ + "static/portfolio-mas-5-f2e261dbf9ff5acb7da05cc4cfc063b9.jpg";